/**
 @ngdoc directive
 @name wordMarker

 @description
 Directive to highlight match words.<br />
 This directive uses Mark.js to highlight words. This utility will highlight the match words using span html element
 For example:
 <span data-markjs="true" class="wordHighlight">matchword</span>

 @param {string=} highlightWords  highlightWords - should be comma separated string contains words needs to be highlighted. <br />

 @see https://markjs.io/
 */
(function () {

    'use strict';

    var commonWords = "and,with,well,if,the,all,such,within,from,to,for,a,above,below,add,there,these,then,would,without,will,whether,use,i,you,us,our,thus,those,there,their,they’re,some,should,shouldn’t,on,of,but,every,include,my,onto,using,with,two,under,role,were,was,using,also,new".split(",");
    var specialCharacters = ["`", "~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "-", "_", "=", "+", "{", "}", "[", "]", "\\", "|", ":", ";", "'", "\"", ",", ".", "<", ">", "/", "?"];

    var wordMarker = function () {
        return {
            restrict: "A",
            scope: true,
            bindToController:{
                highlightWords: "@"
            },
            controllerAs: 'ctrl',
            controller: function(){
            },
            replace: false,
            transclude: false,
            require: 'wordMarker',
            link: function (scope, element, attrs, ctrl) {
                if (angular.isDefined(ctrl.highlightWords) && ctrl.highlightWords.length > 0) {
                    var options = {
                        "element": "span",
                        "className": "wordHighlight",
                        "ignoreJoiners": false,
                        "caseSensitive": false,
                        "ignorePunctuation": specialCharacters,
                        "accuracy": {
                            "value": "exactly",
                            "limiters": specialCharacters
                        }
                    };
                    var highlightWords = ctrl.highlightWords.split(/\s*,\s*/);
                    for (var index in highlightWords) {
                        if(highlightWords[index].length > 0 && commonWords.indexOf(highlightWords[index]) == -1) {
                            element.mark(highlightWords[index], options);
                        }
                    }
                }
            }
        };
    };
    angular.module('app').directive('wordMarker', wordMarker);
}());